
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Technologie', path: '/tech' },
    { name: 'Carrières', path: '/carrieres' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md py-2 border-b border-sand-300 shadow-sm' : 'bg-transparent py-4'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center group">
            <img 
              src="/logo.png" 
              alt="PrimeConnect Logo" 
              className="h-20 w-auto object-contain transition-transform group-hover:scale-105"
              onError={(e) => {
                // Fallback UI if the image link is not available yet
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                target.parentElement!.innerHTML += '<div class="flex items-center space-x-2"><div class="w-10 h-10 bg-gradient-to-br from-prime-blue to-prime-green rounded-lg"></div><span class="text-2xl font-bold text-prime-dark">Prime<span class="font-light">Connect</span></span></div>';
              }}
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-semibold tracking-wide transition-colors hover:text-prime-blue ${location.pathname === link.path ? 'text-prime-blue' : 'text-slate-600'}`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/contact" className="bg-prime-dark hover:bg-slate-900 text-white px-6 py-2.5 rounded-full text-sm font-bold shadow-lg shadow-prime-dark/20 transition-all flex items-center group">
              Audit Gratuit
              <ChevronRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Mobile Toggle */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-prime-dark">
              {isOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden bg-sand-100 border-b border-sand-300 absolute w-full left-0 py-4 px-4 shadow-2xl">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsOpen(false)}
              className="block py-4 text-slate-800 font-medium border-b border-sand-200 last:border-0"
            >
              {link.name}
            </Link>
          ))}
          <Link to="/contact" onClick={() => setIsOpen(false)} className="block mt-4 text-center bg-prime-dark text-white py-3 rounded-xl font-bold">
            Audit Gratuit
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
